import React                          from 'react';
import PropTypes                      from 'prop-types';
import Dropdown                       from './NavbarMessagesDropdown';
import Translations                   from '../../utils/Translations';
import Flux                           from '../../flux/Flux';
import PrivateTicketShowInvitationBox from "../VXMessenger/PrivateTicketShowInvitationBox";
import { onClick }                    from './NavbarHelper';

class NavbarMessages extends React.PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			messages:              this.props.initialMessages,
			unreadMessagesCount:   this.props.initialUnreadMessagesCount,
			privateShowInvitation: null,
		};

		Flux.Messenger.setUnreadMessagesCount(this.props.initialUnreadMessagesCount);

		this.onMessagesChange              = this.onMessagesChange.bind(this);
		this.onPrivateTicketShowInvitation = this.onPrivateTicketShowInvitation.bind(this);
	}

	componentDidMount() {
		Flux.Messenger.addNavbarMessageChangeListener(this.onMessagesChange);
		Flux.NewMessenger.addPrivateTicketShowInvitationListener(this.onPrivateTicketShowInvitation);
	}

	componentWillUnmount() {
		Flux.Messenger.removeNavbarMessageChangeListener(this.onMessagesChange);
		Flux.NewMessenger.removePrivateTicketShowInvitationListener(this.onPrivateTicketShowInvitation);
	}

	onMessagesChange() {
		this.setState({
			messages:            Flux.Messenger.getNavbarMessages(),
			unreadMessagesCount: Flux.Messenger.getUnreadMessagesCount(),
		});
	}

	onPrivateTicketShowInvitation(invitation) {
		this.setState({
			privateShowInvitation: invitation,
		});
	}

	render() {
		// create unread item count label
		let badge = false;
		if (this.state.unreadMessagesCount > 0) {
			badge = <span className="badge--number animated--jump">{this.state.unreadMessagesCount}</span>;
		}

		// Dropdown menu (don't render menu on server!)
		const dropdown = (
			<Dropdown
				messages={this.state.messages}
				messengerUrl={this.props.messengerUrl}
			/>
		);

		let privateShowInvitation = null;
		if (this.state.privateShowInvitation) {
			privateShowInvitation = (
				<PrivateTicketShowInvitationBox
					{...this.state.privateShowInvitation}
					onClose={
						() => {
							this.setState({privateShowInvitation: null});
						}
					}
				/>);
		}

		return (
			<div className="navigation__link">
				<a href="#"
				   id="messageCount"
				   data-toggle="dropdown"
				   className="js-dropdown-toggle navigation__link"
				   role="button"
				   aria-haspopup="true"
				   aria-expanded="false"
				   data-tooltip-content={Translations.get('NavbarMessengerTooltip')}
                   data-tooltip-id="tooltip-bottom"
				   onClick={onClick}
				>
					<i className="navigation__icon -icon-chat-flat"/><span
					className="navigation__label">{Translations.get('NavbarMessagesLabel')}</span>{badge}
				</a>
				{dropdown}
				{privateShowInvitation}
			</div>
		);
	}
}

NavbarMessages.propTypes = {
	initialMessages:            PropTypes.array,
	initialUnreadMessagesCount: PropTypes.number,
	messengerUrl:               PropTypes.string,
};

export default NavbarMessages;
